module.exports = __webpack_public_path__ + "static/test5-4b20d0dee91b91353f4f732e2d45105e.jpg";